import type { ElementType } from "react";

import { Indicator } from "@mantine/core";

import { TextWrapper } from "../../components/TextWrapper";

interface NavBarIconProps {
  Icon: ElementType;
  /** Accessible name of the icon; omitted when the icon has none. */
  ariaLabel?: string;
  /** Shows a count badge on the icon while `count` is above zero. */
  badge?: { count: number; ariaLabel: string };
}

/** The side nav icon for one module, with an optional count badge capped at 99. */
export default function NavBarIcon({ Icon, ariaLabel, badge }: NavBarIconProps) {
  const icon = <Icon size={24} aria-label={ariaLabel} color="var(--mantine-color-dark-9)" />;

  if (!badge?.count) return icon;

  return (
    <Indicator
      inline
      size={16}
      offset={2}
      color="red.7"
      display="flex"
      position="top-end"
      label={
        <TextWrapper c="white" size="xs" variant="bold" aria-label={badge.ariaLabel}>
          {Math.min(badge.count, 99)}
        </TextWrapper>
      }
    >
      {icon}
    </Indicator>
  );
}
